import { useContext } from 'react';
import { AuthContext } from '@/App';
import { usePermissionContext } from '@/contexts/PermissionContext';
import { AccessLevel, PageKey } from '@/types/permissions';

const LEVELS: Record<AccessLevel, number> = {
  NONE: 0,
  VIEWOWN: 1,
  READ: 2,
  READWRITE: 3,
  ADMIN: 4,
};

interface UsePermissionsOptions {
  pageKey?: PageKey;
  projectId?: string;
}

export function usePermissions({ pageKey, projectId }: UsePermissionsOptions = {}) {
  const { permissions, loading } = usePermissionContext();
  const { user } = useContext(AuthContext);

  let level: AccessLevel = 'NONE';

  if (permissions && pageKey) {
    level = permissions.global[pageKey] || 'NONE';
    if (projectId && permissions.projects && permissions.projects[projectId]) {
      const override = permissions.projects[projectId][pageKey];
      if (override) {
        level = override;
      }
    }
  }

  const currentLevel = LEVELS[level] || 0;

  return {
    level,
    loading,
    canRead: currentLevel >= LEVELS.VIEWOWN,
    canWrite: currentLevel >= LEVELS.READWRITE,
    canAdmin: currentLevel >= LEVELS.ADMIN,
    permissions,
    userRole: user?.globalRole || 'USER',
  };
}
